import * as Yup from 'yup';
import { STATE_REQUIRED } from '../../../constant/message';

export const stateSchema = Yup.object().shape({
  name: Yup.string().required(STATE_REQUIRED),
});
